import snakecaseKeys from 'snakecase-keys';

/** Converts camelCase object keys to snake_case for API request bodies using deep conversion. */
export const serializeRequestBody = <T extends Record<string, unknown>>(obj: T) => snakecaseKeys(obj, { deep: true });
